// extracted by mini-css-extract-plugin
export default {"employee-header":"Header_employee-header__EA6su","employee-header__buttons":"Header_employee-header__buttons__+Wgtk","employee-header-item":"Header_employee-header-item__-l975"};